import { FileType } from '@previo/codebooks'

export enum PFileVariant {
  SQUARE = 'square',
  FILL = 'fill',
}

export enum PFileType {
  IMAGE = FileType.IMAGE,
  PDF = FileType.PDF,
  CSV = FileType.CSV,
  JSON = FileType.JSON,
  XML = FileType.XML,
  GPC = FileType.GPC,
  TXT = FileType.TXT,
  WORD = FileType.WORD,
  EXCEL = FileType.EXCEL,
  OTHER = FileType.OTHER,
}
